import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { TracInviteTypes } from '@services/invites/types/invite-types';
import { TracInvite, NewTracInvite } from '@services/invites/types/trac-invite';
import { ErrorAction } from '../common/error-action';
import { Action } from 'redux';
import SimpleArtist from '@common/types/artist/simple-artist';
import SimpleUser from '../../../../../common/types/user/simple-user';

export class GetInvites implements LoadingAction {
  readonly type = actions.GET_INVITES;
  readonly isLoading = true;

  constructor(public inviterId: string, public inviteType: TracInviteTypes) {}
}

export class GetInvitesSuccess implements LoadingAction {
  readonly type = actions.GET_INVITES_SUCCESS;
  readonly isLoading = false;

  constructor(
    public inviteType: TracInviteTypes,
    public invites: TracInvite[]
  ) {}
}

export class GetInvitesError implements ErrorAction {
  readonly type = actions.GET_INVITES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetUserInvites implements LoadingAction {
  readonly type = actions.GET_USER_INVITES;
  readonly isLoading = true;
}

export class GetUserInvitesSuccess implements LoadingAction {
  readonly type = actions.GET_USER_INVITES_SUCCESS;
  readonly isLoading = false;

  constructor(public invites: TracInvite[]) {}
}

export class GetUserInvitesError implements ErrorAction {
  readonly type = actions.GET_USER_INVITES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetRecordLabelInvites implements LoadingAction {
  readonly type = actions.GET_RECORD_LABEL_INVITES;
  readonly isLoading = false;

  constructor(
    public recordLabelId: string,
    public inviteType: TracInviteTypes
  ) {}
}

export class GetRecordLabelInvitesSuccess implements LoadingAction {
  readonly type = actions.GET_RECORD_LABEL_INVITES_SUCCESS;
  readonly isLoading = false;

  constructor(
    public inviteType: TracInviteTypes,
    public invites: TracInvite[]
  ) {}
}

export class GetRecordLabelInvitesError implements ErrorAction {
  readonly type = actions.GET_RECORD_LABEL_INVITES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CancelInvite implements LoadingAction {
  readonly type = actions.CANCEL_INVITE;
  readonly isLoading = true;

  constructor(public invite: TracInvite) {}
}

export class CancelInviteSuccess implements LoadingAction {
  readonly type = actions.CANCEL_INVITE_SUCCESS;
  readonly isLoading = false;

  constructor(public invite: TracInvite) {}
}

export class CancelInviteError implements ErrorAction {
  readonly type = actions.CANCEL_INVITE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ResendInvite implements LoadingAction {
  readonly type = actions.RESEND_INVITE;
  readonly isLoading = true;

  constructor(public invite: TracInvite) {}
}

export class ResendInviteSuccess implements LoadingAction {
  readonly type = actions.RESEND_INVITE_SUCCESS;
  readonly isLoading = false;
}

export class ResendInviteError implements ErrorAction {
  readonly type = actions.RESEND_INVITE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class CreateInvites implements LoadingAction {
  readonly type = actions.CREATE_INVITES;
  readonly isLoading = true;

  constructor(public inviteType: TracInviteTypes, public redirect?: string) {}
}

export class CreateInvitesSuccess implements LoadingAction {
  readonly type = actions.CREATE_INVITES_SUCCESS;
  readonly isLoading = false;

  constructor(
    public inviteType: TracInviteTypes,
    public invites: TracInvite[]
  ) {}
}

export class CreateInvitesError implements ErrorAction {
  readonly type = actions.CREATE_INVITES_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class AcceptInvite implements LoadingAction {
  readonly type = actions.ACCEPT_INVITE;
  readonly isLoading = true;

  constructor(public invite: TracInvite) {}
}

export class AcceptInviteSuccess implements LoadingAction {
  readonly type = actions.ACCEPT_INVITE_SUCCESS;
  readonly isLoading = false;

  constructor(public invite: TracInvite) {}
}

export class AcceptInviteError implements ErrorAction {
  readonly type = actions.ACCEPT_INVITE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class RejectInvite implements LoadingAction {
  readonly type = actions.REJECT_INVITE;
  readonly isLoading = true;

  constructor(public invite: TracInvite) {}
}

export class RejectInviteSuccess implements LoadingAction {
  readonly type = actions.REJECT_INVITE_SUCCESS;
  readonly isLoading = false;

  constructor(public invite: TracInvite) {}
}

export class RejectInviteError implements ErrorAction {
  readonly type = actions.REJECT_INVITE_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class NewInviteDraft implements Action {
  readonly type = actions.NEW_INVITE_DRAFT;

  constructor(
    public inviteType: TracInviteTypes,
    public inviter: SimpleArtist | SimpleUser
  ) {}
}

export class EditInviteDraft implements Action {
  readonly type = actions.EDIT_INVITE_DRAFT;

  constructor(
    public inviteType: TracInviteTypes,
    public key: string,
    public invite: Partial<NewTracInvite>
  ) {}
}

export class RemoveInviteDraft implements Action {
  readonly type = actions.REMOVE_INVITE_DRAFT;

  constructor(public inviteType: TracInviteTypes, public key: string) {}
}

export class ResetInvitesStore implements Action {
  readonly type = actions.RESET_INVITES_STORE;
}

export type InviteActions =
  | GetInvites
  | GetInvitesSuccess
  | GetInvitesError
  | GetUserInvites
  | GetUserInvitesSuccess
  | GetUserInvitesError
  | CreateInvites
  | CreateInvitesSuccess
  | CreateInvitesError
  | NewInviteDraft
  | EditInviteDraft
  | RemoveInviteDraft
  | CancelInvite
  | CancelInviteSuccess
  | CancelInviteError
  | ResendInvite
  | ResendInviteSuccess
  | ResendInviteError
  | AcceptInvite
  | AcceptInviteSuccess
  | AcceptInviteError
  | RejectInvite
  | RejectInviteSuccess
  | RejectInviteError
  | ResetInvitesStore
  | GetRecordLabelInvites
  | GetRecordLabelInvitesSuccess
  | GetRecordLabelInvitesError;
